import React, { Component } from 'react';
import './App.css';
import web3 from './web3';
import rht from './rht';
import busd from './busd';

class App extends Component {
  state = {
    RHTaddress:'0x90D5eb808e8463239262c0f476A2BF0f29B6811b',
    owner: '',
    totalSupplyWholeNumber: '',
    RHTvalueBuy: '',
    BUSDbalance:'',
    tokenBurnsLenght:'',
    RHTvalueSell:'',
    messagewhenMint:'',
    messageMint:'',
    messageSell: '',
    messageReceive:'',
    messagewhenSell:'',
    messageSend:'',
    _sentAmountSell: '',
    _sentAmountSend:'',
    _sentAmountMint: '',
    _sentAmountwhenMint:'',
    _sentAmountReceive:'',
    _sentAmountwhenSell:'',
  };

  async componentDidMount() {
    const owner = await rht.methods.owner().call();
    const totalSupplyWholeNumber = await rht.methods.totalSupplyWholeNumber().call();
    const RHTvalueBuy = await rht.methods.showRHTvalueForBuywithoutTrigger().call();
    const RHTvalueSell = await rht.methods.showRHTvalueForSellwithoutTrigger().call();
    const BUSDbalance = await rht.methods.balanceInPool().call();
    const tokenBurnsLenght = await rht.methods.tokenBurnsLenght().call();

    this.setState({ owner, totalSupplyWholeNumber, RHTvalueBuy, BUSDbalance, tokenBurnsLenght, RHTvalueSell});
  }

  onSubmitReceive = async (eventReceive) => {
    eventReceive.preventDefault();
  
    this.setState({ messageReceive: 'Please wait a short moment...' });
  
    const receive = await rht.methods.getReceivedAmount(web3.utils.toWei(this.state._sentAmountReceive, 'ether')).call();

    this.setState({ messageReceive: 'The recipient receives '+ web3.utils.fromWei(receive.receivedAmount, 'ether')+' RHT and '+web3.utils.fromWei(receive.feeAmount, 'ether')+' RHT are burned. '  });
  }

  onSubmitSend = async (eventSend) => {
    eventSend.preventDefault();
  
    this.setState({ messageSend: 'Please wait a short moment...' });
  
    const send = await rht.methods.getSendAmount(web3.utils.toWei(this.state._sentAmountSend, 'ether')).call();

    this.setState({ messageSend: 'There will be '+ web3.utils.fromWei(send.sendAmount, 'ether')+' RHT debited and from it will be burned '+web3.utils.fromWei(send.feeAmount, 'ether')+' RHT.'  });
  }

  onSubmitExactSend = async (eventExactSend) => {
    eventExactSend.preventDefault();

    const accounts = await web3.eth.getAccounts();
  
    this.setState({ messageExactSend: 'Waiting on transaction success...' });
  
    await rht.methods.transferExactDest(this.state._sentAmountExactSendAdress,web3.utils.toWei(this.state._sentAmountExactSend, 'ether')).send({from: accounts[0]});
  
    this.setState({ messageExactSend: 'Successfully credited '+this.state._sentAmountExactSend+' RHT on the address '+this.state._sentAmountExactSendAdress});
  }

  onSubmitwhenMint = async (eventwhenMint) => {
    eventwhenMint.preventDefault();

    this.setState({ messagewhenMint: 'Waiting on transaction success...' });

    const whenmint = await rht.methods.AmountYouGetForBUSDwhenMinting(web3.utils.toWei(this.state._sentAmountwhenMint, 'ether')).call();
  
    this.setState({ messagewhenMint: 'You would receive '+web3.utils.fromWei(whenmint, 'ether')+' RHT !'});
  }

  onSubmitMint = async (eventMint) => {
    eventMint.preventDefault();

    const accounts = await web3.eth.getAccounts();
  
    this.setState({ messageMint: 'Waiting on transaction success...' });
  
    await busd.methods.approve(this.state.RHTaddress ,web3.utils.toWei(this.state._sentAmountMint, 'ether')).send({from: accounts[0]});

    this.setState({ messageMint: 'Waiting on transaction success...' });
  
    await rht.methods.buyRHT(web3.utils.toWei(this.state._sentAmountMint, 'ether')).send({from: accounts[0]});

    const mint = await rht.methods.AmountYouGetForBUSDwhenMinting(web3.utils.toWei(this.state._sentAmountMint, 'ether')).call();
  
    this.setState({ messageMint: 'The minting of the RHT was successful. You have been credited with '+web3.utils.fromWei(mint, 'ether')+' RHT !'});
  }

  onSubmitwhenSell = (eventwhenSell) => {
    eventwhenSell.preventDefault();
  
    this.setState({ messagewhenSell: 'You currently receive '+ this.state._sentAmountwhenSell*web3.utils.fromWei(this.state.RHTvalueSell, 'ether') +' BUSD.'  });
  }

  onSubmitSell = async (eventSell) => {
    eventSell.preventDefault();

    const accounts = await web3.eth.getAccounts();
  
    this.setState({ messageSell: 'Waiting on transaction success...' });
  
    await rht.methods.sellRHT(this.state._sentAmountSell).send({from: accounts[0]});
  
    this.setState({ messageSell: 'The deposited BUSD were successfully paid out ! You have received at least '+web3.utils.fromWei(this.state.RHTvalueSell, 'ether')*(this.state._sentAmountSell)+' BUSD ! (Values can be slightly higher).'});
  }

  render() {
  return (
    <div className='AppText'>
      <div className='Ü1'><h1>RHT - RaddixHodlToken Contract</h1></div>
      <hr />
      <form onSubmit={this.onSubmitReceive}>
        <div className='arrivesText'>
          <label>How much RHT arrives at the recipient when i send </label>
          <input 
            value={this.state.value}
            onChange={eventReceive => this.setState({ _sentAmountReceive: eventReceive.target.value })}
          /><label> RHT </label><button>Show</button>
        </div>
      </form>
      <p className='messageText'>{this.state.messageReceive}</p>
      <hr />
      <form onSubmit={this.onSubmitSend}>
        <div className='sendText'>
          <label>How much RHT will be deducted from my wallet if I send </label>
          <input 
            value={this.state.value}
            onChange={eventSend => this.setState({ _sentAmountSend: eventSend.target.value })}
          /><label> via Exact Amount Send? </label><button>Show</button>
        </div>
      </form>
      <p className='messageText'>{this.state.messageSend}</p>
      <hr />
      <form onSubmit={this.onSubmitExactSend}>
        <div className='exactText'>
          <label>Send exact amount: </label>
          <input 
            value={this.state.value}
            onChange={eventExactSend => this.setState({ _sentAmountExactSend: eventExactSend.target.value })}
          /><label> RHT should arrive at the following address: </label><input 
          value={this.state.value}
          onChange={eventExactSend => this.setState({ _sentAmountExactSendAdress: eventExactSend.target.value })}
        /><button>Send</button>
        </div>
      </form>
      <p className='messageText'>{this.state.messageExactSend}</p>
      <hr />
      <form onSubmit={this.onSubmitwhenMint}>
        <div className='whenMintText'>
          <label>How much RHT would I get when minting : </label>
          <input 
            value={this.state.value}
            onChange={eventwhenMint => this.setState({ _sentAmountwhenMint: eventwhenMint.target.value })}
          /><label> BUSD </label><button>Show</button>
        </div>
      </form>
      <p className='messageText'>{this.state.messagewhenMint}</p>
      <hr />
      <form onSubmit={this.onSubmitMint}>
        <div className='mintText'>
        <p>Please note, there is a 4.5% fee, to find out how much RHT you will receive, use the function above !</p>
          <label>Mint RHT in amount of BUSD : </label>
          <input 
            value={this.state.value}
            onChange={eventMint => this.setState({ _sentAmountMint: eventMint.target.value })}
          /><button>Mint</button>
        </div>
      </form>
      <p className='messageText'>{this.state.messageMint}</p>
      <hr />
      <form onSubmit={this.onSubmitwhenSell}>
        <div className='arrivesText'>
          <label>How much BUSD will I receive if I redeem/sell </label>
          <input 
            value={this.state.value}
            onChange={eventwhenSell => this.setState({ _sentAmountwhenSell: eventwhenSell.target.value })}
          /><label> RHT </label><button>Show</button>
        </div>
      </form>
      <p className='messageText'>{this.state.messagewhenSell}</p>
      <hr />
      <form onSubmit={this.onSubmitSell}>
        <div className='sellText'>
          <label>Sell RHT in amount of (whole numbers only) : </label>
          <input 
            value={this.state.value}
            onChange={eventSell => this.setState({ _sentAmountSell: eventSell.target.value })}
          /><label> RHT </label><button>Get deposit</button>
        </div>
      </form>
      <p className='messageText'>{this.state.messageSell}</p>
      <hr />
      <div className='statusText'>
      <p>The Total Supply at the moment is {this.state.totalSupplyWholeNumber} RHToken. This number is rounded down to a whole number.</p>
      <p>For this purpose {web3.utils.fromWei(this.state.BUSDbalance, 'ether')} BUSD have been secured in the contract.</p>
      <p>The current value of an RHT is {web3.utils.fromWei(this.state.RHTvalueBuy, 'ether')} BUSD</p>
      <p>There are {this.state.tokenBurnsLenght} imaginary burns going on right now. Each one lasts exactly 9 weeks and reduces the payout value a little bit.</p> 
      <p>The current payout value is {web3.utils.fromWei(this.state.RHTvalueSell, 'ether')} BUSD per token.</p>
      </div>
    </div>
  );
  };
}

export default App;
